import React from 'react'
import { useNavigate } from 'react-router-dom'

import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ToolTip from 'components/Common/ToolTip'
import RiskScoreTooltipContent from './RiskScoreTooltipContent'
import RiskClassTooltipContent from './RiskClassTooltipContent'
import SectionTitle from 'components/Common/SectionTitle'
import { Divider, Link } from '@mui/material'
import { useSelector } from 'react-redux'
import BusinessCreditChart from 'components/Common/BusinessCreditProgress/BusinessCreditChart'
import BusinessCreditTooltip from './BusinessCreditTooltip'

const ProfileCardContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'left',
}))

const BusinessSummary = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  justifyContent: 'space-between',
}))

const ProfileCompletedProgress = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}))

const UnclaimedUser = props => {
  const navigate = useNavigate()
  const user = useSelector(state => state.userReducer.user)

  const goToDashboard = () => {
    navigate('/find')
  }

  const goToWelcome = () => {
    navigate('/welcome')
  }

  return (
    <>
      <Box
        sx={{
          textAlign: 'left',
        }}
      >
        <SectionTitle title="Business Health Metrics" />
      </Box>
      <ProfileCardContainer>
        <BusinessSummary>
          <Box
            sx={{
              textAlign: 'left',
            }}
          >
            <Box sx={{ marginBottom: '40px' }}>
              <Typography component="div" sx={{ fontSize: '14px' }} color="primary">
                Business Credit Risk Score <sup style={{ left: '-0.3em' }}>TM</sup>
                <ToolTip component="span" content={<RiskScoreTooltipContent />} />
              </Typography>
              <Box>
                <Link onClick={goToDashboard} target="_blank" underline="hover">
                  <Typography
                    component="span"
                    variant="button3"
                    color="secondary"
                    sx={{ cursor: 'pointer', fontSize: '12px' }}
                  >
                    Claim your business to see your score
                  </Typography>
                </Link>
              </Box>
            </Box>
            <Divider
              variant="left"
              sx={{
                borderWidth: '1px',
                Color: '#CEE4F5',
                width: '240px',
                marginBottom: '20px',
              }}
            />
            <Box sx={{ marginBottom: '40px' }}>
              <Typography component="div" sx={{ fontSize: '14px' }} color="primary">
                Business Credit Risk Class <sup style={{ left: '-0.3em' }}>TM</sup>
                <ToolTip component="span" content={<RiskClassTooltipContent />} />
              </Typography>
              <Box>
                <Link onClick={goToDashboard} target="_blank" underline="hover">
                  <Typography
                    component="span"
                    variant="button3"
                    color="secondary"
                    sx={{ cursor: 'pointer', fontSize: '12px' }}
                  >
                    Claim your business to see your score
                  </Typography>
                </Link>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              textAlign: 'left',
            }}
          >
            <Box sx={{ marginLeft: '40px' }}>
              <Typography component="div" sx={{ fontSize: '14px' }} color="primary">
                Business Credit Score&nbsp;
                <ToolTip component="span" content={<BusinessCreditTooltip />} />
              </Typography>
              <Box>
                {user?.accountType === 'free' ? (
                  <Link onClick={goToWelcome} target="_blank" underline="hover">
                    <Typography
                      component="span"
                      variant="button3"
                      color="secondary"
                      sx={{ cursor: 'pointer', fontSize: '12px' }}
                    >
                      Claim your business and become a premium member to see your score!
                    </Typography>
                  </Link>
                ) : (
                  <Link onClick={goToDashboard} target="_blank" underline="hover">
                    <Typography
                      component="span"
                      variant="button3"
                      color="secondary"
                      sx={{ cursor: 'pointer', fontSize: '12px' }}
                    >
                      Claim your business to see your score
                    </Typography>
                  </Link>
                )}
              </Box>
              <Box>
                <ProfileCompletedProgress>
                  <BusinessCreditChart
                    //   value={ }
                    size="normal"
                    style={{ marginTop: '30px' }}
                  />
                </ProfileCompletedProgress>
              </Box>
            </Box>
          </Box>
        </BusinessSummary>
      </ProfileCardContainer>
    </>
  )
}

export default UnclaimedUser
